export type DRF_Report_Problem_Tenure_Issue = "DRF_Report_Problem_Tenure_Issue";
export type Help_and_Support_Not_Found = "Help_and_Support_Not_Found";

export type DRF_Payment_Research_And_Refund = "DRF_Payment_Research_And_Refund";

export type FlowId = DRF_Report_Problem_Tenure_Issue | Help_and_Support_Not_Found | DRF_Payment_Research_And_Refund;
const FlowIdArray: Record<string, FlowId> = {
  "/support/issue-reporting/payment-refund": "DRF_Payment_Research_And_Refund",
  "/support/membership": "DRF_Report_Problem_Tenure_Issue",
};
export const flowId: FlowId =
  FlowIdArray[
    window.location.pathname.lastIndexOf("/") === window.location.pathname.length - 1
      ? window.location.pathname.substring(0, window.location.pathname.lastIndexOf("/")).toLowerCase()
      : window.location.pathname.toLowerCase()
  ] || "Help_and_Support_Not_Found";
